const Style = {
    footer: 'border-t border-border bg-surface py-14',
    inner: 'mx-auto max-w-6xl px-6',

    columns: 'grid grid-cols-2 gap-10 md:grid-cols-4',

    // icon + wordmark. `w-auto` keeps /assets/icon.png's ~1.4:1 ratio intact.
    brand: 'mb-2 flex items-center gap-2 text-lg font-bold text-primary-600',
    brandMark: 'h-7 w-auto shrink-0',
    tagline: 'text-sm text-text-secondary',

    column: 'flex flex-col gap-2.5',
    heading: 'text-xs font-semibold uppercase tracking-[0.06em] text-text-muted',
    link: 'text-sm text-text-secondary no-underline transition-colors duration-150 ease-out hover:text-primary-600',

    bottom:
        'mx-auto mt-10 max-w-6xl border-t border-border px-6 pt-6 text-xs text-text-muted',
};

export default Style;
